import React from "react";
import { Link } from "react-router-dom";

const TermsAndConditionsComponent = () => {
  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div className="container">
        <div className="main-body">
          <div className="row gutters-sm justify-content-center">
            <div className="col-md-12">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "30px",
                  fontWeight: "600",
                  textTransform: "uppercase",
                }}
              >
                Terms & Conditions – Laundry Portal Services
              </h1>
              <h3
                style={{
                  textAlign: "center",
                  fontWeight: "600",
                  paddingBottom: "10px",
                  fontSize: "23px",
                  marginBottom: "10px",
                }}
              >
                Please Read These Terms Carefully
              </h3>
              <h4
                style={{
                  textAlign: "center",
                  fontWeight: "600",
                  paddingBottom: "40px",
                  marginBottom: "40px",
                  borderBottom: " 1px solid #1ea3fe",
                }}
              >
                By using the “Laundry Portal” Platform you confirm you agree to
                the following terms.
              </h4>
              <h3 class="wp-block-heading101">
                1. Who We Are and What This Agreement Discusses
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                If your Resident Country is the U.A.E. then this contract shall
                be between you and Connection Hub Portal incorporated in Dubai
                with commercial registration number 818893, located in Airport
                Road Showroom, Port Saeed, Dubai, UAE.
                <br /> <br />
                The company referred to above shall be referred to as “Laundry
                Portal” throughout the rest of this contract.
                <br /> <br />
                Laundry Portal licenses you to use its online Platform detailed
                as: Laundry Portal mobile application software, the data
                supplied with the software, and any updates or supplements to it
                together with the related online or electronic documentation
                including in the Laundry Portal Website
                https://thelaundryportal.com (“Platform”).
                <br /> <br />
                The services you connect to via the above mentioned Platform and
                the content we provide to you through it for personal dry
                cleaning or laundry services collected from and delivered to
                your nominated address (“Services”).
                <br /> <br />
                The use by you of the Platform and the Services from within any
                country are governed by these terms that will outline the terms
                of use for the Laundry Portal Platform.
              </p>
              <h3 class="wp-block-heading101">1. Your Privacy</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                We only use any personal data we collect through your use of the
                Platform and the Services in the ways set out in our privacy
                policy found at:
                <br /> <br />
                The company referred to above shall be referred to as “Laundry
                Portal” throughout the rest of this contract.
              </p>
              <p style={{ fontSize: "30px", paddingLeft: "33px" }}>
                |&nbsp;&nbsp;
                <span
                  style={{
                    fontSize: "18px",
                    textDecoration: "underline",
                    fontStyle: "italic",
                  }}
                >
                  <Link to={"/"}>Home</Link>
                </span>
                <br />
              </p>
              <p style={{ fontSize: "18px" }}>
                Please be aware that correspondence made over the internet are
                never completely private or secure and that any message or
                information you send using the Platform or any Service may be
                read or intercepted by others, even on a special notice that a
                particular transmission is encrypted.
              </p>
              <h3 class="wp-block-heading101">2. Definitions</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                Several words have been defined for further clarity. When the
                first letter of these words are capitalized throughout these
                “Terms & Conditions” the following definitions should be used:
                <br /> <br />
                “Item”: any article of clothing collected from you in connection
                with a submitted Order.
                <br /> <br />
                “Order”: your Order for the Services as set out in the Order
                form submitted via the platform.
                <br /> <br />
                “Pick-up Time”: the time scheduled for the collection of the
                Order from the address provided by the User.
                <br /> <br />
                “Resident Country”: the jurisdiction in which your Laundry
                Portal account is linked either through your use of the same or
                as determined by Laundry Portal based upon data associated with
                your Laundry Portal account.
                <br /> <br />
                “Service Providers”: all the laundries signed with us to provide
                the Services.
                <br /> <br />
                “Terms”: these terms and conditions, which are liable to be
                amended from time to time.
                <br /> <br />
                “You”: the party who agrees to these Terms and uses the
                Platform, and its respective Services.
                <br /> <br />
                “User”: any party who downloads and uses the Platform.
                <br /> <br />
                “We”/”Our”/”Us”: Laundry Portal, team and company and
                representatives.
              </p>
              <h3 class="wp-block-heading101">
                3. Membership and Use of the Laundry Portal Services
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                3.1 Every user of Laundry Portal, once registered, has a ‘user
                name’ and ‘password’ that are selected by the User themselves.
                The ‘user name’ is personal to the User and the same ‘user name’
                is not given to two different Users. The ‘password’ is only
                known by the User. The User can change the password at any time.
                As User, you acknowledge that you will select and protect the
                password at all times.
                <br /> <br />
                3.2 Laundry Portal shall not be liable for any problems that may
                arise from the use of the password. Laundry Portal may inform
                the user by email about any promotions that take place in the
                Users’ area and from which the user may benefit.
                <br /> <br />
                3.3 By using the Platform, you warrant that any personal
                information input by you, including credit card information, is
                true, accurate, current and complete in all respects and that
                you will notify us immediately of any changes to your personal
                information, by updating your profile on the platform or by
                contacting us via customer care at info@thelaundryportal.com You
                agree not to impersonate any other person or entity or to use a
                false name or a name that you are not authorized to use.
              </p>
              <h3 class="wp-block-heading101">
                4. Services Offered By Laundry Portal
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                4.1 Laundry Portal allows its users (who accept this Terms of
                use) to use its respective Services.
                <br /> <br />
                4.2 Laundry Portal provides a method for you to use the Services
                and communicate your Orders for Pick-Up and delivery using
                Service Providers across the city.
                <br /> <br />
                4.3 The objective of Laundry Portal is to provide a simple and
                convenient service to consumers, connecting them to Service
                Providers who offer dry cleaning and laundry services in their
                area.
                <br /> <br />
                4.4 Laundry Portal does not sell or interfere in any way in the
                execution of any services carried out at the Service Providers
                but what our online market offers to Users is the ability to
                search and find local laundries that Pick Up and deliver laundry
                to their addresses and enable the ordering of this service
                through the Laundry Portal Platform. The Service Providers are
                obligated to comply with country local laws, rules, regulations,
                and standard industry practice.
                <br /> <br />
                4.5 It is important for users to understand that Laundry Portal
                does not in any way independently verify the credentials,
                representations or services of the Service Providers, the
                quality of any Services, or that a Service Provider is in
                compliance with all applicable laws. Users must satisfy
                themselves through information provided by the Service Providers
                on the Laundry Portal Platforms or as requested by users
                directly from the Service Providers as to the quality and
                reliability of the Service Providers, as well as to their
                compliance with applicable laws.
                <br /> <br />
                4.6 Laundry Portal does not in any way provide any warranty or
                guarantee as to the quality of any Services or that any Service
                complies with applicable laws and does not guarantee matching
                the Services menu and price list displayed on the Laundry Portal
                Platforms with what is actually provided to the users.
              </p>
              <h3 class="wp-block-heading101">
                5. Placing Orders With Laundry Portal
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                5.1 Users are required to ensure that they check the details of
                their Order carefully before submitting, as we will not be
                liable to you for any errors that you make. If you think that
                you may have made a mistake, please contact us as soon as
                possible through the customer support via the Platform or at
                info@thelaundryportal.com. We will confirm any changes to your
                Order via email or via the Platform.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                5.2 Submission of an Order does not create a contract between
                us.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                5.3 We will assign an Order number to each Order and inform you
                of it when it has been accepted. Please quote the Order number
                in all subsequent communications with us.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                5.4 We will let you know if for any reason we are unable to
                fulfill your Order.
              </p>

              <h3 class="wp-block-heading101">6. Order Changes</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                6.1 You may make a change to an Order only before checking out.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                6.2 With your consent and at our discretion, we may make a
                change to your Order as an alternative to cancelling it in the
                circumstances set out in paragraph 7. This shall be entirely at
                our discretion but we shall endeavor to accommodate any changes
                if possible. Where changes are made to an Order that is
                accepted, we will re-issue the Order confirmation to you via the
                platform or email.
              </p>

              <h3 class="wp-block-heading101">7. Cancelling Your Order</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                7.1 You may make a change to an Order only before checking out.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                7.2 While every effort is made to ensure that accurate pricing
                and descriptions are maintained, we reserve the right to cancel
                any Order that is based on inaccurate information.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                7.3 You acknowledge that once an Item has been collected from
                yourself and the Service process has started, any rights of
                cancellation you may have under these Terms and/or Consumer
                Rights or any equivalent law or regulations will be lost.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                7.4 We may cancel your Order and the agreement between you and
                us in the following circumstances:
              </p>
              <ul>
                <li className="dot101">
                  as a result of an Event Outside Our Control; or
                </li>
                <li className="dot101">
                  if you fail to make Items available for collection; or
                </li>
                <li className="dot101">
                  if we consider that any Item: does not correspond with the
                  Order, is damaged, has no information about its content or
                  cleaning instructions, does not fall within those Items which
                  are accepted by Service Providers or
                </li>
                <li className="dot101">
                  if the Service Provider elects to cancel the Order, before or
                  after acceptance.
                </li>
              </ul>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                If we cancel your Order we will contact you immediately by phone
                or email, and the Service Provider will arrange to redeliver the
                Item(s) to you at the original redelivery time or as soon as
                reasonably practicable.
              </p>

              <h3 class="wp-block-heading101">8. Collection And Re-Delivery</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                8.1 The Service Provider will use reasonable methods to collect
                and re-deliver Items at the times specified in the Order but the
                Service Provider cannot guarantee to do so. We will use
                reasonable methods to communicate any delay to you by phone or
                email.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                8.2 During any item Pick Up or delivery made by any of our
                Service Providers, if the user is not available at the address
                specified in the system and time selected, the Items ordered to
                be cleaned by the user shall not be picked up or delivered from
                anywhere else. In such circumstances, the user must accept all
                legal responsibilities arising from the ordering of our Services
                to an address where he/she does not reside.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                8.3 If delivery is not possible due to the user being
                unavailable at the designated time, Laundry Portal will work to
                find a suitable redelivery time. However, if a redelivery is
                urgent, it is the user’s responsibility to organize a same day
                courier or collection from the Service Provider.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                8.4 If you have failed to accept or arrange redelivery of an
                Item for more than 90 days after the redelivery date specified
                in the Order, we may donate it to an accredited charity of
                Laundry Portal’s choice.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                8.5 You may arrange to have Items collected from, or
                re-delivered to, a third party, on condition that you do so at
                your own risk and the third party is prepared to receive the
                order by an acknowledgement on your behalf.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                8.6 You may, by written instructions to us, request us to leave
                an Item in an agreed location without providing us with a
                signature of acknowledgement. If you do so, it is at our
                discretion and entirely at your own risk and we shall not be
                liable to you for any damage or loss of Items re-delivered on
                this basis.
              </p>

              <h3 class="wp-block-heading101">9. Service Standards</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                9.1 The Services will be provided with reasonable care and skill
                in accordance with industry standards.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                9.2 We will not be liable for any delay or non-performance of
                the Services where you have failed to provide accurate
                information in your Order, for example if an address is
                incomplete as per the fields requested in the Laundry Portal
                Platform or inaccurate, or if you fail to accept redelivery of
                Items in accordance with an Order.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                9.3 Please ensure that you thoroughly check all the Items for
                extraneous items e.g. currency notes, coins, pens, keys, etc. as
                we hold no responsibility for any of these items lost or damaged
                as a result of the cleaning process.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                9.4 As the Service Providers process a high volume of orders
                they will not be able to cater to personal requirements (e.g.
                temperature, washing powders, etc.). Neither We nor the Service
                Providers will accept any responsibility if there is any color
                transfer during the cleaning process.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                9.5 We will not be liable for damage to Items as the Service
                Providers wash by the load and do not inspect the care labels of
                each garment. For Items that need to be specially treated i.e.
                leather, silk, cashmere, fur, velvet and other delicate
                garments, please ensure that these items can be machine washed
                and tumble dried before using our Services for these Items.
              </p>

              <h3 class="wp-block-heading101">10. Price</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                The price of the Services will be set out in our price list as
                included in the platform and will be the price in force at the
                time you place your Order. Our prices may change at any time,
                but price changes will not affect Orders that have already been
                accepted.
              </p>

              <h3 class="wp-block-heading101">11. Payment</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                11.1 Once your Order has been accepted, this represents an
                agreement between you and the Service Provider. The Service
                Provider has sole responsibility for the Order. Cash payments
                are made directly to the Service Provider upon delivery to
                fulfill the Order.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                11.2 If you have chosen to pay with using your debit/credit card
                on the platform, the transaction will be processed by Laundry
                Portal as agent of the Service Provider.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                11.3 The user is liable to pay by cash upon delivery any extra
                charges the Service Provider might charge as a result of the
                ‘Special Request’ or the ‘General Request’ placed by the user.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                11.4 The user refund procedure might take 5-10 working days to
                process on Debit/Credit cards bank Payment Gateway. We will send
                an email to the user that contains a printout of the refund
                advice printed from Debit/Credit Cards bank payment gateway as
                reference in case the user wants to advise the bank. The user
                has to follow on with the bank in case of any delay in crediting
                back the user’s account with the amount previously paid by the
                user.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                11.5 Users using the Payment Gateway facility are requested to
                be available on their respective contact numbers.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                11.6 The user is entirely liable for placing an Order using the
                Payment Gateway facility after carefully reading these terms of
                use.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                11.7 Credit and/or Debit cards used in placing orders through
                the online payment gateway on platform must belong to the user.
                Otherwise, the user must obtain the legal permission from the
                card owner to perform the transaction.
              </p>

              <h3 class="wp-block-heading101">
                12. Limitation of Our Liability to You
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                12.1 In the unlikely event of loss or damage to an Item, Laundry
                Portal will use its reasonable influence to ensure that the
                Service Provider who carries principal liability for any loss or
                damage pays compensation in line with standard industry
                guidelines. For the avoidance of doubt, the total liability to
                you of the Service Provider (or Laundry Portal in the event of
                failure by the Service Provider to pay) in respect of each Item
                is limited to the applicable compensation limits in place with
                each Service Provider from time to time or five (5) times the
                price you are charged for the Services in respect of that item,
                whichever is the higher amount. Any loss or damage must be
                reported to us within seven days through digital photographs or
                via phone or email: info@thelaundryportal.com.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                12.2 We only supply the Services for domestic and private use.
                If you are using our Services for any commercial, business or
                re-sale purpose, we have no liability to you for any loss of
                profit, loss of business, business interruption, or loss of
                business opportunity.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                12.3 Neither We nor the Service Providers will be responsible
                for any loss or damage (including, without limitation) any color
                loss, shrinkage or other damage, resulting from the following:
              </p>
              <ul>
                <li className="dot101">
                  failure to notify us of any special requirements or
                  instructions for cleaning the Item;
                </li>
                <li className="dot101">
                  any existing damage to the Item at the time of collection.
                </li>
              </ul>

              <h3 class="wp-block-heading101">13. Complaints</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                13.1 Laundry Portal takes customer satisfaction very seriously.
                In appropriate cases where you already have been billed by
                Laundry Portal a full or partial refund may apply. In the
                following cases:
              </p>
              <ul>
                <li className="dot101">
                  if you do not receive your Order;
                </li>
                <li className="dot101">
                  have received an incorrect Order;
                </li>
              </ul>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                you may be issued a full refund. If part of your Order is
                missing we may issue a partial refund. In every event, we will
                do our best to ensure you are completely satisfied with the
                outcome.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                13.2 If you have a complaint about the Services, we will deal
                with it in accordance with our Complaints Policy. You will not
                have to pay for us to deal with your complaint. Complaints
                should be notified to us within 24 hours of redelivery of any
                Item if you believe that we are in breach of our obligations
                under these Terms. However, if you are not completely satisfied
                then simply contact us within 24 hours of redelivery via our
                Customer Care team – details of which appear in clause 37 below.
                Any complaints submitted after 24 hours will be considered on a
                discretionary basis.
              </p>

              <h3 class="wp-block-heading101">
                14. Circumstances Outside Our Control
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                14.1 We will not be liable or responsible for any failure to
                perform, or delay in performance of, any of our obligations
                under these Terms that is caused by Circumstances Outside Our
                Control.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                14.2 Circumstances Outside Our Control means any act or event
                beyond our reasonable control, or the reasonable control of any
                of our Service Providers including (without limitation) strikes,
                lock-outs or other industrial action by third parties, civil
                commotion, riot, invasion, terrorist attack or threat of
                terrorist attack, war (whether declared or not) or threat or
                preparation for war, fire, explosion, storm, flood, earthquake,
                subsidence, epidemic or other natural disaster, or closure or
                failure of public infrastructure or public or private
                telecommunications networks.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                14.3 If Circumstances Outside Our Control takes place that
                affects the performance of our obligations under these Terms we
                will contact you as soon as reasonably possible to notify you;
                and Our obligations under these Terms will be suspended and the
                time for performance of our obligations will be extended for the
                duration of the Circumstances Outside Our Control; or You may
                cancel your Order or we may cancel it.
              </p>

              <h3 class="wp-block-heading101">15. Promo Codes & Offers</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                15.1 Promo Codes and Offers are subject to expiry dates.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                15.2 These Terms apply to all Laundry Portal offers/promo codes.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                15.3 Offers cannot be used in conjunction with any other Laundry
                Portal Promo Codes or any other offers. Promo Codes cannot be
                used in conjunction with any other Laundry Portal Offers or any
                other offers.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                15.4 Only one offer or code may be used per transaction.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                15.5 Promo codes are strictly non-transferable, and have no cash
                value.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                15.6 Laundry Portal reserves the right to reject a voucher with
                reasonable cause.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                15.7 Laundry Portal reserves the right to withdraw an offer at
                any time and without warning.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                15.8 Referral vouchers cannot be used in conjunction with any
                other customer offer or promotion.
              </p>
              <h3 class="wp-block-heading101">16. Platform Usage Rights</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                16.1 In return for your agreement to comply with these terms you
                may:
              </p>
              <ul>
                <li className="dot101">
                  download or stream a copy of the platform onto your personal
                  device and view, use and display the platform and the services
                  on such devices for your personal use only.
                </li>
                <li className="dot101">
                  receive and use any free supplementary software code or
                  updates of the Platform incorporating ‘patches’ and
                  corrections of errors as we may provide to you which is
                  complementary.
                </li>
                <li className="dot101">
                  not, and will not encourage, assist or authorize any other
                  person to copy, modify, reverse engineer, decompile or
                  disassemble, or otherwise tamper with, the online Platform,
                  whether in whole or in part, or create any derivative works
                  from or of the Laundry Portal platforms.
                </li>
              </ul>

              <h3 class="wp-block-heading101">
                17. How You May Use Material On Our Platform
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                17.1 We are the owner or the licensee of all intellectual
                property rights in our Platform, and materials published on it.
                These works are protected by copyright laws and treaties around
                the world. All such rights are reserved.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                17.2 You must not modify the paper or digital copies of any
                materials you have printed off or downloaded in any way, and you
                must not use any illustrations, photographs, video or audio
                sequences or any graphics separately from any accompanying text.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                17.3 Our status (and that of any identified contributors) as the
                authors of content on our platforms must always be acknowledged.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                17.4 You must not use any part of the content on our platform
                for commercial purposes without obtaining a license to do so
                from Us or our licensors.
              </p>

              <h3 class="wp-block-heading101">
                18. You May Not Transfer Your Account To Someone Else
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                We are giving you personally the right to use the Platform and
                it’s related Services as set out above for personal use only.
                Whilst you may have sharing rights as set out above, you may not
                otherwise transfer the Platform or its related Services to
                someone else, whether for money, for anything else or for free.
                If you sell any device on which the platform is installed, you
                must remove the platform from it immediately. Therefore, as
                stated the license to use these platforms or its related
                services are not transferable.
              </p>

              <h3 class="wp-block-heading101">
                19. Changes to Terms and Conditions
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                19.1 We may need to change these terms to reflect changes in law
                or best practice or to deal with additional features which we
                introduce. We may update and change our platforms from time to
                time to reflect changes to our Services, our users’ needs and
                our business priorities. We will try to give you reasonable
                notice of any major changes.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                19.2 We will notify of any change by sending you a notification
                through the platform’s applications and may ask you to reaccept
                the updated Terms & Conditions along with its Privacy Policy.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                19.3 If you do not accept the notified changes you may continue
                to use the platform and the service in accordance with the
                existing terms but certain new features may not be available to
                you.
              </p>

              <h3 class="wp-block-heading101">
                20. Updates to the Platform and Updates to Our Service
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                20.1 From time to time we may automatically update the Platform
                and change the Services to improve performance, enhance
                functionality, reflect changes to the operating system or
                address security issues. Alternatively, we may ask you to update
                the Platform for these reasons.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                20.2 If you choose not to install such updates or if you opt out
                of automatic updates you may not be able to continue using the
                Platform and the related Services or certain new features may
                not be available to you.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                20.3 The platform will always work with the current (current
                being defined as the version released to use at least 6 months
                prior) or previous version of the operating system (as it may be
                updated from time to time) and match the description of it
                provided to you when you downloaded it.
              </p>

              <h3 class="wp-block-heading101">
                21. We May Collect Technical Data From Your Device
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                By using the Platform or any of its Services, you agree to us
                collecting and using technical information about the devices you
                use the platform on and the related software, hardware and
                peripherals to improve our products and services.
              </p>

              <h3 class="wp-block-heading101">22. Location Data</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                Certain Services including Auto filling of Address of your
                profile and tracking will make use of location data sent from
                your devices. You can turn off this functionality at any time by
                turning off the location services on the device. If you use
                these Services, you consent to us and our affiliates’ and
                licensees’ transmission, collection, retention, maintenance,
                processing and use of your location data and queries to provide
                and improve location-based and road traffic-based products and
                services.
              </p>

              <h3 class="wp-block-heading101">
                23. We Are Not Responsible For Other Websites You Link To
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                23.1 The Platform may contain links to other independent
                websites that are not provided by us. Such independent sites are
                not under our control, and we are not responsible for and have
                not checked and approved their content or their privacy policies
                (if any).
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                23.2 You will need to make your own independent judgments about
                whether to use any such independent sites, including whether to
                buy any products or services offered by them. Such links should
                not be interpreted as approved by us of those linked websites or
                information you may obtain from them. We have no control over
                the contents of those sites or resources.
              </p>

              <h3 class="wp-block-heading101">
                24. User Generated Content Is Not Approved By Us
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                Our Platform may include information and materials uploaded by
                other users of the Platform. This information and these
                materials have not been verified or approved by us. The views
                expressed by other users on our Platform do not represent our
                views or values. If you wish to complain about information and
                materials uploaded by other users please contact our Customer
                Care team – details of which appear in clause 37 below.
              </p>

              <h3 class="wp-block-heading101">
                25. Acceptable Use Restrictions
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                25.1 You must:
              </p>
              <ul>
                <li className="dot101">
                  not use the Platforms or any of its Service in any unlawful
                  manner, for any unlawful purpose, or in any manner
                  inconsistent with these terms, or act fraudulently or
                  maliciously, for example, by hacking into or inserting
                  malicious code, such as viruses, or harmful data, into the
                  Platforms or any of its Services or any operating system;
                </li>
                <li className="dot101">
                  not infringe our intellectual property rights or those of any
                  third party in relation to your use of the Platform or any of
                  its Services (to the extent that such use is not licensed by
                  these terms);
                </li>
                <li className="dot101">
                  not transmit any material that is defamatory, offensive or
                  otherwise objectionable in relation to your use of the
                  Platform or any of its Services;
                </li>
                <li className="dot101">
                  not use the Platform or any of its Services in a way that
                  could damage, disable, overburden, impair or compromise our
                  systems or security or interfere with other users; and
                </li>
                <li className="dot101">
                  not collect or harvest any information or data from any
                  Service or our systems or attempt to decipher any
                  transmissions to or from the servers running any Service.
                </li>
              </ul>

              <h3 class="wp-block-heading101">
                26. Intellectual Property Rights
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                All intellectual property rights in the Platform and its related
                documentation and the Services belong to Laundry Portal and the
                rights in the Platform and the Services are licensed (not sold)
                to you for personal use only. You have no intellectual property
                rights in, or to, the Platform or the related Documentation or
                the Services other than the right to use them in accordance with
                these terms.
              </p>

              <h3 class="wp-block-heading101">
                27. You Must Keep Your Account Details Safe
              </h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                27.1 If you choose, or you are provided with, a user
                identification code, password or any other piece of information
                as part of our security procedures, you must treat such
                information as confidential. You must not disclose it to any
                third party.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                27.2 We have the right to disable any user identification code
                or password, whether chosen by you or allocated by us, at any
                time, if in our reasonable opinion, you have failed to comply
                with any of the provisions of these terms of use.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                27.3 If you know or suspect that anyone other than you have
                knowledge of your user identification code or password, you must
                promptly our Customer Care team – details of which appear in
                clause 37 below.
              </p>

              <h3 class="wp-block-heading101">28. Limitation of Liability</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                28.1 To the maximum extent permitted by the applicable laws,
                Laundry Portal excludes all responsibility and liability in
                relation to the Platform and Services and disclaims all
                warranties (express or implied) and representations (including
                without limitation implied warranties of merchantability and
                suitability for a particular purpose) regarding the use or the
                results of the use of the Platform or any linked websites in
                terms of their correctness, accuracy, timeliness, reliability,
                or otherwise.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                28.2 Laundry Portal will not be responsible for errors or
                misstatements or be liable, whether in contract, tort (including
                negligence) or otherwise, for any loss or damage howsoever
                caused (including direct, indirect, consequential, special
                losses, or loss of profits). Further, Laundry Portal does not
                warrant that the functions contained in the Platform will be
                uninterrupted or error-free, that defects will be corrected, or
                that the Platform or the server that makes it available, are
                free of viruses or other harmful components.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                28.3 You agree to release Laundry Portal from all claims arising
                from any statement or representation made on the Platform. Your
                sole and exclusive remedy for any claim against Laundry Portal
                or any dispute with Laundry Portal, our affiliates, and their
                respective officers, directors, employees, shareholders or
                agents of any of them, is to discontinue your use of the
                Platform.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                28.4 We are not liable for business losses. The Platform is for
                domestic and private use. If you use the Platform for any
                commercial, business or resale purpose we will have no liability
                to you for any loss of profit, loss of business, business
                interruption, or loss of business opportunity.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                28.5 The Platform and its related Services are provided for
                general information purposes only. They do not offer advice on
                which you should rely. You must obtain professional or
                specialist advice before taking, or refraining from, any action
                on the basis of information obtained from the Platforms or its
                related Services. Although we make reasonable efforts to update
                the information provided by the Platforms and the Services, we
                make no representations, warranties or guarantees, whether
                express or implied, that such information is accurate, complete
                or up to date.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                28.6 Check that the Platform and the Services are suitable for
                you. The Platform and its related Services have not been
                developed to meet your individual requirements. Please check
                that the facilities and functions of the Platform and its
                related Services to evaluate its usage towards meeting your
                requirements.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                28.7 We do not guarantee that our Platform will be secure or
                free from bugs or viruses. You are responsible for configuring
                your information technology, computer programs and platform to
                access our Platform. You should use your own virus protection
                software. You must not misuse our Platform by knowingly
                introducing viruses, trojans, worms, logic bombs or other
                material that is malicious or technologically harmful. You must
                not attempt to gain unauthorized access to our Platform, the
                server on which our site is stored or any server, computer or
                database connected to our Platform. You must not attack our site
                via a denial-of-service attack or a distributed denial-of
                service attack. By breaching this provision, you would commit a
                criminal offence. We will report any such breach to the relevant
                law enforcement authorities and we will co-operate with those
                authorities by disclosing your identity to them. In the event of
                such a breach, your right to use our Platform will cease
                immediately.
              </p>
              <h3 class="wp-block-heading101">29. Termination of Services Due To Breach Of Terms of Use</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                29.1 We may terminate your rights to use the Platform and its
                related Services at any time if you have breached these terms in
                a serious way. If what you have done can be put right we will
                give you a reasonable opportunity to do so.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                29.2 If we end your rights to use the Platform and related
                Services:
              </p>
              <ul>
                <li className="dot101">
                  You must stop all activities authorised by these terms,
                  including your use of the Platform and any of its related
                  Services.
                </li>
                <li className="dot101">
                  You must delete or remove the Platform from all devices in
                  your possession and immediately destroy all copies of the
                  Platform which you have and confirm to us that you have done
                  this.
                </li>
                <li className="dot101">
                  We may remotely access your devices, verify and remove the
                  Platform from them and cease providing you with access to the
                  Services.
                </li>
                <li className="dot101">
                  We do not guarantee that our Platforms, or any content on it,
                  will always be available or be uninterrupted. We may suspend
                  or withdraw or restrict the availability of all or any part of
                  our Platforms for business and operational reasons.
                </li>
                <li className="dot101">
                  We will try to give you reasonable notice of any suspension or
                  withdrawal.
                </li>
              </ul>

              <h3 class="wp-block-heading101">30. We May Transfer This Agreement To Someone Else</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                We may transfer our rights and obligations under these terms to
                another organisation. We will inform you via publications or
                platform notification if this happens and we will ensure that
                the transfer will not affect your rights under the contract.
              </p>

              <h3 class="wp-block-heading101">31. No Rights For Third Parties</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                This agreement does not give rise to any rights to Third Parties
                unless specified herein.
              </p>

              <h3 class="wp-block-heading101">32. Partial Enforceability</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                Each of the clauses outlined herein operates separately. If any
                court or relevant authority decides that any of them are
                unlawful, the remaining paragraphs will remain in full force and
                effect.
              </p>

              <h3 class="wp-block-heading101">33. Delayed Enforceability</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                We reserve the right to enforce the clauses outlined herein even
                if, for whatever reason, they are delayed.
              </p>

              <h3 class="wp-block-heading101">34. Indemnification</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                You agree to indemnify, defend and hold harmless Laundry Portal,
                its parent company, subsidiaries, affiliates, officers,
                directors, employees, agents, information providers and
                suppliers from and against all losses, expenses, damages and
                costs, including reasonable lawyers’ fees, resulting from any
                violation of these Terms, breach of your representations
                contained in these Terms or any activity related to your account
                (including infringement of any intellectual property rights or
                negligent or wrongful conduct) by you or any person accessing
                the platform using your account.
              </p>

              <h3 class="wp-block-heading101">35. Applicable Laws & Legal Proceedings</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                The law of the United Arab Emirates (UAE) governs these terms.
                In the event of a dispute, claim or disagreement that cannot be
                resolved amicably between User and Laundry Portal, it is agreed
                either party shall be at liberty to bring legal proceedings in
                the Dubai Courts.
              </p>

              <h3 class="wp-block-heading101">36. Customer Care Team / Complaints</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                36.1 Our Customer Care teams are as follows: For the U.A.E. –
                [Phone: +971 50 242 0030 Email: info@thelaundryportal.com ]
                Please contact our Customer Care team and tell us as soon as
                reasonably possible if you encounter a problem with the
                Services, if you want to learn more about our Platforms or the
                Services we offer or have any problems using them.
              </p>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                36.2 If you think our Platforms or of the Services we provide
                are faulty or misdirected or wish to contact us for any other
                reason please contact our Customer Care team.
              </p>

              <h3 class="wp-block-heading101">37. Registered Trademarks</h3>
              <p style={{ fontSize: "18px", textAlign: "justify" }}>
                The Laundry Portal trademark is a UAE registered trademark of
                Connection Hub Portal. You are not permitted to use it without
                our approval, unless it is part of material you are using as
                permitted under these Terms and with the consent of Laundry
                Portal.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditionsComponent;
